export const extensionRoutes = [  {
    path: 'extensions/create-store',
    loadChildren: () => import('./extensions/default-store-user-ui/routes'),
  }];
